import styled from '../../../theme'

const HeaderWrapper = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0px 20px;
`

export default HeaderWrapper
